import {FilterConverter} from "../filter/FilterConverter";
import {FiltersStateInitializer} from "../defaultInitializer/FiltersStateInitializer";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

export async function getDwellingMetrics(filters, stationCode, view, dispatcher, leg, isCPTFilterEnabled) {
    const metricProcessName = "SCC_PACKAGE_" + view;

    var initializedFilters = FiltersStateInitializer(filters, [])
    const modifiedRequest = await FilterConverter(initializedFilters, view, leg , null, null ,[], isCPTFilterEnabled);

    const request = {

        resourcePath: "/os/getDwellingPackageData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: {
            "nodeId": stationCode,
            "view": view,
            "filters": modifiedRequest,
            "leg": leg
        }
    }

    const startTime = Date.now();

    getAPIGatewayDataFromParent(request).then(result => {
            if (result.status === 200) {

                logOperationalMetric(startTime, metricProcessName, "getDwellingPackageData", true);
                dispatcher({type: "RECEIVED_DATA", data: {
                    isLoading: false,
                    metricResult: result.data.metricResult,
                    stationTimeZone: result.data.stationTimeZone,
                    viewTypeForStation: result.data.viewTypeForStation,
                    rtsAgeingGenericLabelsEnabled: result.data.rtsAgeingGenericLabelsEnabled
        }})} else {

            logOperationalMetric(startTime, metricProcessName, "getDwellingPackageData", false);
            dispatcher({type: "RECEIVED_DATA", data: {
                isLoading: false,
                metricResult: []
        }})}
    }).catch (() =>  {
        //TODO : Display empty datatable when data not available or failure
        dispatcher({type: "RECEIVED_DATA", data: {
            isLoading: false,
            metricResult: []
    }})
    });
}


// WEBPACK FOOTER //
// ./src/commons/api/GetViewMetrics.js